import { styled } from "@mui/material/styles";

export const FormContainer = styled("form")(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  width: 300,
  padding: theme.spacing(2),
  gap: theme.spacing(1),

  [theme.breakpoints.down(576)]: {
    width: "100%",
    padding: 0,
  },
}));
